<template>
  <div
    class="prominent-button"
    :class="[color,{subActive:subActive}]"
    @click="onclick()"
  >
    <i
      class="leading-icon"
      :class="leadingIcon"
    />
    <button>
      {{ $t(textLabel) }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ProminentButton",
  props: {
    leadingIcon: {
      type: String,
      default: ""
    },
    iconGradient: {
      type: String,
      default: ""
    },
    textLabel: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    subActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onclick() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/prominent-button";
</style>